import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Results } from '@local/client-contracts';
import { InvokeCommand } from '../../models/invoke-command.model';
import { RadiusType } from '../result-rich-text-block/result-rich-text-block.component';

@Component({
  selector: 'result-rich-text-list',
  templateUrl: './result-rich-text-list.component.html',
  styleUrls: ['./result-rich-text-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultRichTextListComponent {
  private _model: Results.RichTextList;
  styleOrderedList: string;
  styleLi: string;

  @Input() set model(val: Results.RichTextList) {
    this._model = val;
    this.styleOrderedList = this.styleList();
    this.styleLi = this.styleLiList;
  }
  @Input() highlights: Array<string>;
  @Input() borderRadius: RadiusType;
  @Output() invoke = new EventEmitter<InvokeCommand>();

  get model(): Results.RichTextList {
    return this._model;
  }

  get isOrdered(): boolean {
    return this.model?.style === 'ordered';
  }

  private get styleLiList(): string {
    let typeList: string = 'none';
    if (!this.isOrdered) {
      typeList = this.bulletListType;
    }
    return `list-style-type: ${typeList}; margin-left: ${this.marginLeftList};`;
  }

  private get bulletListType(): string {
    switch (this.model?.indent % 3) {
      case 0:
        return 'disc';
      case 1:
        return 'circle';
      case 2:
        return 'square';
    }
  }

  private get marginLeftList(): string {
    return `${this.model?.indent * 20 + 30}px`;
  }

  private styleList(): string {
    const counterSet = this.model?.offset ? this.listCounter(this.model?.indent + 1) : '';
    return `counter-reset: ${this.listCounter(this.model?.indent + 1)}; counter-set: ${counterSet};`;
  }

  private listCounter(index: number): string {
    let listCounter: string = '';
    for (let i: number = index; i < 9; i++) {
      listCounter += `list-${i} `;
    }
    return listCounter;
  }
}
